document.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
  const target = document.querySelector(link.getAttribute('href'));
  if (target) { event.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
}));

const formatDh = cents => `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(cents / 100)} DH`;

document.querySelectorAll('[data-mobile-menu]').forEach(menu => {
  const toggle = document.querySelector(`[aria-controls="${menu.id}"]`);
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  const closeButton = menu.querySelector('[data-mobile-menu-close]');
  if (!toggle || !overlay || !closeButton) return;

  const setMenuOpen = open => {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    menu.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('mobile-menu-open', open);
    if (open) closeButton.focus();
    else if (document.activeElement === closeButton) toggle.focus();
  };

  toggle.addEventListener('click', () => setMenuOpen(toggle.getAttribute('aria-expanded') !== 'true'));
  closeButton.addEventListener('click', () => setMenuOpen(false));
  overlay.addEventListener('click', () => setMenuOpen(false));
  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenuOpen(false)));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setMenuOpen(false);
  });
});

document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const track = gallery.querySelector('[data-product-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-product-slide]')];
  const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
  const counter = gallery.querySelector('[data-gallery-counter]');
  const previous = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  if (!track || slides.length < 2) return;

  let activeIndex = 0;
  let scrollFrame;

  const updateGallery = index => {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === activeIndex;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
    if (previous) previous.disabled = activeIndex === 0;
    if (next) next.disabled = activeIndex === slides.length - 1;
  };

  const goToSlide = index => {
    const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
    track.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: 'smooth' });
    updateGallery(targetIndex);
  };

  track.addEventListener('scroll', () => {
    window.cancelAnimationFrame(scrollFrame);
    scrollFrame = window.requestAnimationFrame(() => {
      const width = track.clientWidth || 1;
      updateGallery(Math.round(track.scrollLeft / width));
    });
  }, { passive: true });

  dots.forEach(dot => dot.addEventListener('click', () => goToSlide(Number(dot.dataset.galleryIndex))));
  if (previous) previous.addEventListener('click', () => goToSlide(activeIndex - 1));
  if (next) next.addEventListener('click', () => goToSlide(activeIndex + 1));
  updateGallery(0);
});

document.querySelectorAll('[data-variant-picker]').forEach(picker => {
  const form = picker.closest('[data-product-form]');
  const variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
  const sizeButtons = [...picker.querySelectorAll('[data-size]')];
  const frameButtons = [...picker.querySelectorAll('[data-frame]')];
  const variantInput = picker.querySelector('[data-variant-id]');
  const selectedSizeLabel = picker.querySelector('[data-selected-size]');
  const selectedFrameLabel = picker.querySelector('[data-selected-frame]');
  const price = form.querySelector('[data-product-price]');
  const addButton = form.querySelector('[data-add-button]');
  const addLabel = form.querySelector('[data-add-label]');

  const partsFor = variant => {
    const [size = '', frame = ''] = variant.title.split(' / ');
    return { size, frame };
  };

  const setActiveSize = button => {
    sizeButtons.forEach(item => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const setActiveFrame = button => {
    frameButtons.forEach(item => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const refreshVariant = () => {
    const activeButton = picker.querySelector('[data-size].is-active') || sizeButtons[0];
    const activeFrameButton = picker.querySelector('[data-frame].is-active') || frameButtons[0];
    const wantedFrame = activeFrameButton.dataset.frame;
    let variant = variants.find(item => {
      const parts = partsFor(item);
      return parts.size === activeButton.dataset.size && parts.frame.toLowerCase() === wantedFrame.toLowerCase();
    });

    if (!variant) variant = variants.find(item => partsFor(item).size === activeButton.dataset.size && item.available);
    if (!variant) return;

    variantInput.value = variant.id;
    selectedSizeLabel.textContent = activeButton.textContent.trim();
    selectedFrameLabel.textContent = partsFor(variant).frame;
    price.textContent = formatDh(variant.price);
    addButton.disabled = !variant.available;
    addLabel.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', nextUrl);
  };

  sizeButtons.forEach(button => button.addEventListener('click', () => {
    setActiveSize(button);
    refreshVariant();
  }));
  frameButtons.forEach(button => button.addEventListener('click', () => {
    setActiveFrame(button);
    refreshVariant();
  }));
  refreshVariant();
});

document.querySelectorAll('[data-product-recommendations]').forEach(section => {
  if (section.innerHTML.trim()) return;
  fetch(section.dataset.url)
    .then(response => response.text())
    .then(text => {
      const page = document.createElement('div');
      page.innerHTML = text;
      const recommendations = page.querySelector('[data-product-recommendations]');
      if (recommendations && recommendations.innerHTML.trim()) {
        section.innerHTML = recommendations.innerHTML;
      } else {
        section.remove();
      }
    })
    .catch(() => section.remove());
});

document.querySelectorAll('[data-purchase-notifications]').forEach(notification => {
  const container = notification.closest('.shopify-section') || notification.parentElement;
  const dataNode = container.querySelector('[data-purchase-json]');
  if (!dataNode) return;

  let dismissed = false;
  try { dismissed = sessionStorage.getItem('purchase-notifications-dismissed') === 'true'; } catch (error) {}
  if (dismissed) return;

  const purchases = JSON.parse(dataNode.textContent);
  if (!purchases.length) return;

  for (let index = purchases.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [purchases[index], purchases[randomIndex]] = [purchases[randomIndex], purchases[index]];
  }

  const image = notification.querySelector('[data-purchase-image]');
  const name = notification.querySelector('[data-purchase-name]');
  const city = notification.querySelector('[data-purchase-city]');
  const product = notification.querySelector('[data-purchase-product]');
  const time = notification.querySelector('[data-purchase-time]');
  const close = notification.querySelector('[data-purchase-close]');
  const startDelay = Number(notification.dataset.startDelay) || 6000;
  const displayTime = Number(notification.dataset.displayTime) || 5000;
  const interval = Number(notification.dataset.interval) || 14000;
  let current = 0;
  let hideTimer;
  let nextTimer;

  const hideNotification = () => {
    notification.classList.remove('is-visible');
    window.setTimeout(() => { notification.hidden = true; }, 400);
  };

  const showNotification = () => {
    const purchase = purchases[current % purchases.length];
    current += 1;
    image.src = purchase.image;
    image.alt = purchase.product;
    name.textContent = purchase.name;
    city.textContent = purchase.city;
    product.textContent = purchase.product;
    time.textContent = purchase.time;
    notification.hidden = false;
    window.requestAnimationFrame(() => notification.classList.add('is-visible'));
    hideTimer = window.setTimeout(() => {
      hideNotification();
      nextTimer = window.setTimeout(showNotification, interval);
    }, displayTime);
  };

  close.addEventListener('click', () => {
    window.clearTimeout(hideTimer);
    window.clearTimeout(nextTimer);
    hideNotification();
    try { sessionStorage.setItem('purchase-notifications-dismissed', 'true'); } catch (error) {}
  });

  nextTimer = window.setTimeout(showNotification, startDelay);
});
